import React from "react";
import { Skeleton, Table, Tag } from "antd";
import { useTranslation } from "react-i18next";

const TransactionTable = ({ selectedTransection, loadingTransection }) => {
  const {t} = useTranslation();
  const columns = [
    // {
    //   title: 'Transaction ID',
    //   dataIndex: '_id',
    //   key: '_id',
    // },
    {
      title: t("Amount"),
      dataIndex: "amount",
      key: "amount",
      render: (text) => `SAR ${text}`,
    },
    {
      title: t("Transaction Type"),
      dataIndex: "transaction_type",
      key: "transaction_type",
      // filters: [
      //   { text: 'Deposit', value: 'deposit' },
      //   { text: 'Withdrawal', value: 'withdrawal' },
      // ],
      // onFilter: (value, record) => record.transaction_type.includes(value),
      render: (type) => {
        let color = type === "deposit" ? "green" : "volcano";
        return <Tag color={color}>{type.toUpperCase()}</Tag>;
      },
    },
    // {
    //   title: 'Created At',
    //   dataIndex: 'created_at',
    //   key: 'created_at',
    //   render: (timestamp) => new Date(timestamp * 1000).toLocaleString(),
    // },
    {
      title: t("Sender"),
      dataIndex: "sender_info",
      key: "sender_info",
      render: (info) =>
        `${info?.first_name} ${info?.last_name} (${info?.email})`,
    },
    {
      title: t("Recipient"),
      dataIndex: "recipient_info",
      key: "recipient_info",
      render: (info) =>
        `${info?.first_name} ${info?.last_name} (${info?.email})`,
    },

    {
      title: t("Transaction Details"),
      dataIndex: "transaction_details",
      key: "transaction_details",
      render: (details, newValue) => newValue?.transaction_type === "cashback" || newValue?.transaction_type === "bill_paid" ? "" : ` Amount: ${details?.amount}`,
    },
    {
      title: t("Payment Type"),
      dataIndex: "transaction_details",
      key: "transaction_details",
      // render: (details) => `${details?.paymenttype}`,
      render: (details, newValue) => newValue?.transaction_type === "cashback" || newValue?.transaction_type === "bill_paid"  ? "" : `${details?.paymenttype}`,

    },
  ];

  return loadingTransection ? (
    <Skeleton active />
  ) : (
    <>
      <Table
        dataSource={selectedTransection?.transactions}
        columns={columns}
        // pagination={{ pageSize: 5 }}
      />
    </>
  );
};

export default TransactionTable;
